@if (topbar(); as topbar) {
  <div class="top-bar-left" *transloco="let t" [class]="'locale-' + locale">
    <div class="top-bar-content-navigation">
      <button
        [title]="t('Previous information')"
        app-button="icon-button"
        class="button-prev"
        (click)="onClickPrev()"
      >
        <svg-icon key="navigation-left" fontSize="12px"></svg-icon>
      </button>
      <button
        [title]="t('Next information')"
        app-button="icon-button"
        class="button-next"
        (click)="onClickNext()"
      >
        <svg-icon key="navigation-right" fontSize="12px"></svg-icon>
      </button>
    </div>

    <div class="top-bar-content" #topBarContent>
      @for (slide of topbar.slides; let isFirst = $first, index = $index; track index) {
        <div class="slide" [ngClass]="isFirst ? 'active' : ''">
          @if (slide.url) {
            <a [routerLink]="slide.url | addLocale">
              {{ slide.content }}
            </a>
          } @else {
            {{ slide.content }}
          }
        </div>
      }
      @defer {
        @if (topbar.timerSlide) {
          <div class="slide">
            @if (topbar.timerSlide.url) {
              <a [routerLink]="topbar.timerSlide.url | addLocale">
                {{ topbar.timerSlide.content }}
                <app-countdown-timer date="2025-01-31T23:59:59"></app-countdown-timer>
              </a>
            } @else {
              {{ topbar.timerSlide.content }}
              <app-countdown-timer date="2025-01-31T23:59:59"></app-countdown-timer>
            }
          </div>
        }
      }
    </div>
  </div>
}

<div class="top-bar-menu" *transloco="let t">
  <a [routerLink]="'/stores' | translateRoute | addLocale">{{ t('Find a store') }}</a>
  <button app-button="icon-button" class="menu-locale" (click)="onOpenLanguagePopup()">
    <div class="locale-currency">
      {{ stateService.activeLocale$ | async }}
      ({{ stateService.activeCurrency$ | async }})
    </div>
    <div class="locale-switcher">{{ t('Display preferences') }}</div>
  </button>
</div>
